import { render, staticRenderFns } from "./EmpleadosInactivos.vue?vue&type=template&id=fd32cc9a&scoped=true"
import script from "./EmpleadosInactivos.vue?vue&type=script&lang=js"
export * from "./EmpleadosInactivos.vue?vue&type=script&lang=js"
import style0 from "./EmpleadosInactivos.vue?vue&type=style&index=0&id=fd32cc9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd32cc9a",
  null
  
)

export default component.exports